var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.63819 2.21967C7.77885 2.07902 7.96961 2 8.16852 2L15.8315 2C16.0304 2 16.2212 2.07902 16.3618 2.21967L21.7803 7.63819C21.921 7.77885 22 7.96961 22 8.16852V15.8315C22 16.0304 21.921 16.2212 21.7803 16.3618L16.3618 21.7803C16.2212 21.921 16.0304 22 15.8315 22H8.16852C7.96961 22 7.77885 21.921 7.63819 21.7803L2.21967 16.3618C2.07902 16.2212 2 16.0304 2 15.8315L2 8.16852C2 7.96961 2.07902 7.77885 2.21967 7.63819L7.63819 2.21967ZM8.47918 3.5L3.5 8.47919L3.5 15.5208L8.47919 20.5H15.5208L20.5 15.5208V8.47919L15.5208 3.5L8.47918 3.5ZM7 11.75C7 11.3358 7.33579 11 7.75 11H16.25C16.6642 11 17 11.3358 17 11.75C17 12.1642 16.6642 12.5 16.25 12.5H7.75C7.33579 12.5 7 12.1642 7 11.75Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocked);
export default __webpack_public_path__ + "static/media/blocked.49d93459.svg";
export { ForwardRef as ReactComponent };